module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "loex"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pxiii"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0006#toc"
    }
  }, [_vm._v("MUSICAL EXAMPLES")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0013#ex0201"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("2.1.")])]), _vm._v(" J. S. Bach, "), _c('i', [_vm._v("Quodlibet")]), _vm._v(" (BWV 524), bars 103–7")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0013#ex0202"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("2.2.")])]), _vm._v(" “Ach, es schmeckt doch gar zu gut,” from the "), _c('i', [_vm._v("Peasant Cantata")]), _vm._v(" (BWV 212/4), bars 11–20")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0013#ex0203"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("2.3.")])]), _vm._v(" J. S. Bach, “Vergnügte Pleißenstadt” (BWV 216/1), bars 10–14")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0013#ex0204"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("2.4.")])]), _vm._v(" J. S. Bach, “Vergnügte Pleißenstadt” (BWV 216/1), bars 16–22")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0013#ex0205"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("2.5.")])]), _vm._v(" J. S. Bach, “Vergnügte Pleißenstadt” (BWV 216/1), bars 74–77")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0013#ex0206"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("2.6.")])]), _vm._v(" J. S. Bach, “Unschuld! Kleinod reiner Seelen” (BWV Anh. 196/2), bars 24–32")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0013#ex0207"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("2.7.")])]), _vm._v(" J. S. Bach, “Spielet, ihr beseelten Lieder,” from "), _c('i', [_vm._v("O angenehme Melodei")]), _vm._v(" (BWV 210a), bars 1–36")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0013#ex0208"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("2.8.")])]), _vm._v(" J. S. Bach, “Spielet, ihr beseelten Lieder” (BWV 210a/2), bars 85–100")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pxiv"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0013#ex0209"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("2.9.")])]), _vm._v(" J. S. Bach, “Spielet, ihr beseelten Lieder” (BWV 210a/2), soprano part, bars 101–29")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0013#ex0210"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("2.10.")])]), _vm._v(" J. S. Bach, “Spielet, ihr beseelten Lieder” (BWV 210a/2), soprano part, bars 141–60")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0013#ex0211"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("2.11.")])]), _vm._v(" J. S. Bach, “Weichet nur, betrübte Schatten” (BWV 202/1), bars 15–24")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0014#ex0301"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("3.1.")])]), _vm._v(" Heinrich Stölzel, “Bist du bei mir” (BWV 508), 1725 Notebook (no. 25)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0014#ex0302"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("3.2.")])]), _vm._v(" [J. S. Bach?], “Gedenke doch, mein Geist” (BWV 509), 1725 Notebook (no. 41)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0014#ex0303"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("3.3.")])]), _vm._v(" J. S. Bach, “Schlummert ein, ihr matten Augen” (BWV 82/3); version for soprano and keyboard from 1725 Notebook (no. 38), bars 1–26")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0014#ex0304"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("3.4.")])]), _vm._v(" J. S. Bach, Sarabande from Partita no. 6 in E Minor (BWV 830/5), bars 1–5")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0014#ex0305"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("3.5.")])]), _vm._v(" J. S. Bach, “Mit Freuden sei die Welt verlassen,” from "), _c('i', [_vm._v("Klagt, Kinder, klagt es aller Welt")]), _vm._v(" (BWV 244a), bars 35–44")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0014#ex0306"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("3.6.")])]), _vm._v(" J. S. Bach, “Mit Freuden sei die Welt verlassen,” from "), _c('i', [_vm._v("Klagt, Kinder, klagt es aller Welt")]), _vm._v(" (BWV 244a), bars 54–62")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0014#ex0307"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("3.7.")])]), _vm._v(" J. S. Bach, “Hemme Dein gequältes Kräncken,” from "), _c('i', [_vm._v("Klagt, Kinder, klagt es aller Welt")]), _vm._v(" (BWV 244a), soprano and continuo lines, bars 17–24")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0015#ex0401"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("4.1.")])]), _vm._v(" Johann Kuhnau, Sonata no. 3, “Jacob’s Wedding,” from "), _c('i', [_vm._v("Musicalische Vorstellung einiger biblischer Historien")]), _vm._v(" (Leipzig: Tietzen, 1700): “Lo sposo amoroso e contento” (The Amorous and Contented Husband), bars 264–71")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pxv"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0015#ex0402"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("4.2.")])]), _vm._v(" J. S. Bach, "), _c('i', [_vm._v("Fantasia pro Organo")]), _vm._v(" (BWV 573), 1722 Notebook (no. 6)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0016#ex0501"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("5.1.")])]), _vm._v(" J. S. Bach, “Ei! wie schmeckt der Coffee süße” (BWV 211/4), bars 21–34")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0016#ex0502"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("5.2.")])]), _vm._v(" J. S. Bach, “Mädchen, die von harten Sinnen” (BWV 211/6), bars 1–14")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0016#ex0503"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("5.3.")])]), _vm._v(" J. S. Bach, “Heute noch” (BWV 211/8), bars 20–28")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0016#ex0504"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("5.4.")])]), _vm._v(" “Die Katze lässt das Mausen nicht” (BWV 211/10), bars 22–27")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0016#ex0505"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("5.5.")])]), _vm._v(" "), _c('i', [_vm._v("Aria di Giovannini")]), _vm._v(", “Willst du dein Herz mir schenken” (BWV 518), 1725 Notebook (no. 37)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0017#ex0601"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("6.1.")])]), _vm._v(" J. S. Bach, “An dir, du Fürbild großer Frauen” (BWV 198/7), bars 13–17")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0017#ex0602"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("6.2.")])]), _vm._v(" J. S. Bach, opening chorus of "), _c('i', [_vm._v("Wer weiß, wie nahe mir mein Ende?")]), _vm._v(" (BWV 27/1), bars 13–25")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0017#ex0603"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("6.3.")])]), _vm._v(" J. S. Bach, “Doch weichet, ihr tollen, vergeblichen Sorgen!” (BWV 8/4), bars 21–28")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0017#ex0604"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("6.4.")])]), _vm._v(" J. S. Bach, “Die Schätzbarkeit der weiten Erden” (BWV 204/4), bars 1–18")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0017#ex0605"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("6.5.")])]), _vm._v(" J. S. Bach, “Ein edler Mensch ist Perlenmuscheln gleich” (BWV 204/7), bars 14–29")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0017#ex0606"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("6.6.")])]), _vm._v(" J. S. Bach, “Himmlische Vergnügsamkeit” (BWV 204/8), bars 16–23")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pxvi"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0017#ex0607"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("6.7.")])]), _vm._v(" J. S. Bach, "), _c('i', [_vm._v("Warum betrübst du dich")]), _vm._v(" (BWV 516), 1725 Notebook (no. 33)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0018#ex0701"
    }
  }, [_vm._v("EXAMPLE "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("7.1.")])]), _vm._v(" Sandy Linzer and Denny Randell, “A Lover’s Concerto,” melody line")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29f86ffe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-yearsley-0009.vue
// module id = 78
// module chunks = 0